import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { createScrollitellingTemplate } from '../scripts/migrateScrollitellingTemplate';
import { templateService } from '../services/templateService';

export const InitializeTemplates: React.FC = () => {
  const { user, userProfile } = useAuth();
  const [needsInit, setNeedsInit] = useState(false);
  const [isInitializing, setIsInitializing] = useState(false);

  const checkTemplates = React.useCallback(async () => {
    if (userProfile?.role !== 'admin') return;
    
    try {
      const templates = await templateService.listTemplates();
      setNeedsInit(templates.length === 0);
    } catch (error) {
      console.error('Error checking templates:', error);
    }
  }, [userProfile?.role]);

  useEffect(() => {
    checkTemplates();
  }, [checkTemplates]);

  const handleInitialize = async () => {
    if (!user || !userProfile) return;
    
    try {
      setIsInitializing(true);
      await createScrollitellingTemplate(user.uid, userProfile.displayName);
      alert('Scroll-i-telling Vorlage erfolgreich erstellt!');
      setNeedsInit(false);
    } catch (error) {
      console.error('Error initializing template:', error);
      alert('Fehler beim Erstellen der Vorlage');
    } finally {
      setIsInitializing(false);
    }
  };

  if (!needsInit || userProfile?.role !== 'admin') return null;

  return (
    <div className="fixed bottom-4 right-4 bg-yellow-50 border-2 border-yellow-400 rounded-lg p-4 shadow-lg max-w-md z-50">
      <h3 className="font-bold text-yellow-900 mb-2">Erstmalige Einrichtung erforderlich</h3>
      <p className="text-sm text-yellow-800 mb-4">
        Es wurden keine Fragebogen-Vorlagen gefunden. Klicken Sie auf "Initialisieren", 
        um die Standard-Vorlage für Scroll-i-telling zu erstellen.
      </p>
      <button
        onClick={handleInitialize}
        disabled={isInitializing}
        className="w-full bg-yellow-600 text-white px-4 py-2 rounded-lg hover:bg-yellow-700 disabled:opacity-50"
      >
        {isInitializing ? 'Initialisiere...' : 'Scroll-i-telling Vorlage erstellen'}
      </button>
    </div>
  );
};

